import type { ReactElement } from "react";
import styles from "./LotScannerLogo.module.css";

export function LotScannerLogo({
  className
}: {
  className?: string;
}): ReactElement {
  return (
    <span
      className={[styles.wordmark, className].filter(Boolean).join(" ")}
      aria-hidden
    />
  );
}
